module.exports = __webpack_public_path__ + "img/chivas-bg-mobile.fd9a9155.jpg";